import { InputAdornment, TextField } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
/*istanbul ignore next */
function CurrencyTextbox(props) {
  const {
    id,
    name,
    value,
    onChange,
    onBlur,
    disabled,
    type,
    maxWholeDigits = 10,
    decimalPlaces = 2,
    fontSize = "inherit",
  } = props;

  const onChangeHandler = (e) => {
    const input = e.target.value;
    if (input === "") {
      onChange("");
      return;
    }
    const parts = input.split(".");
    const intPart = parts[0] || "";
    const fracPart = parts[1] || "";
    if (intPart.length > maxWholeDigits) return;
    if (
      parts.length === 2 &&
      intPart.length === maxWholeDigits &&
      fracPart === ""
    )
      return;
    if (fracPart.length > decimalPlaces) return;
    if (!/^\d*(\.\d*)?$/.test(input)) return;
    onChange(input);
  };

  const onBlurHandler = (e) => {
    const input = e.target.value;
    if (input === "") {
      onChange("");
    } else {
      const parsed = Number.parseFloat(input);
      if (!Number.isNaN(parsed)) {
        onChange(parsed.toFixed(decimalPlaces));
      }
    }
    // Call external onBlur if provided
    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <div>
      <TextField
        type={type}
        id={id}
        name={name}
        value={value ?? ""}
        size="small"
        className="currency-text-box customtextwidth form-control-input"
        InputProps={{
          startAdornment: <InputAdornment position="start">$</InputAdornment>,
          className: "input-border",
          sx: {
            "& .MuiInputBase-input": {
              fontSize: fontSize,
            },
          },
        }}
        min={0}
        onChange={onChangeHandler}
        onBlur={onBlurHandler}
        disabled={disabled}
      />
    </div>
  );
}

CurrencyTextbox.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  maxWholeDigits: PropTypes.number,
  decimalPlaces: PropTypes.number,
  fontSize: PropTypes.string,
};

CurrencyTextbox.defaultProps = {
  name: "",
  value: "",
  onBlur: undefined,
  disabled: false,
  type: "text",
  maxWholeDigits: 10,
  decimalPlaces: 2,
};

export default CurrencyTextbox;
